import { useSelector } from "react-redux";

/**
 * A custom hook to check settings values from the Redux store
 * @param {string} key - The setting key to check
 * @returns {boolean} Whether the setting is enabled/exists
 */
const useCheckSetting = (key) => {
	const { data } = useSelector((state) => state.settings);
	return data?.[key];
};

export default useCheckSetting;
